export default __webpack_public_path__ + "static/user3-13553eb9573344ae28bc26ff6dbbe39d.jpg";